import { isEmpty, invalidEmail, errorMessages } from "utils/validation";

export default function validate({ email }) {
  let errors = {};

  if (isEmpty(email)) {
    errors.email = errorMessages.emptyValue;
  } else if (invalidEmail(email)) {
    errors.email = errorMessages.invalidEmail;
  }

  return errors;
};